/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { EnumerationQuantityDtoQuantityUsageType } from './EnumerationQuantityDtoQuantityUsageType';
import {
    EnumerationQuantityDtoQuantityUsageTypeFromJSON,
    EnumerationQuantityDtoQuantityUsageTypeFromJSONTyped,
    EnumerationQuantityDtoQuantityUsageTypeToJSON,
} from './EnumerationQuantityDtoQuantityUsageType';
import type { EvaluationQuantityUsageDto } from './EvaluationQuantityUsageDto';
import {
    EvaluationQuantityUsageDtoFromJSON,
    EvaluationQuantityUsageDtoFromJSONTyped,
    EvaluationQuantityUsageDtoToJSON,
} from './EvaluationQuantityUsageDto';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { SetupQuantityUsageDto } from './SetupQuantityUsageDto';
import {
    SetupQuantityUsageDtoFromJSON,
    SetupQuantityUsageDtoFromJSONTyped,
    SetupQuantityUsageDtoToJSON,
} from './SetupQuantityUsageDto';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';

/**
 * 
 * @export
 * @interface NumericQuantityDto
 */
export interface NumericQuantityDto {
    /**
     * 
     * @type {string}
     * @memberof NumericQuantityDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof NumericQuantityDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof NumericQuantityDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericQuantityDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof NumericQuantityDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericQuantityDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof NumericQuantityDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof NumericQuantityDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof NumericQuantityDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof NumericQuantityDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof NumericQuantityDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof NumericQuantityDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof NumericQuantityDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof NumericQuantityDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof NumericQuantityDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof NumericQuantityDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof NumericQuantityDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof NumericQuantityDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof NumericQuantityDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {StateOfUse}
     * @memberof NumericQuantityDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof NumericQuantityDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof NumericQuantityDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof NumericQuantityDto
     */
    description?: string | null;
    /**
     * 
     * @type {EnumerationQuantityDtoQuantityUsageType}
     * @memberof NumericQuantityDto
     */
    quantityUsageType?: EnumerationQuantityDtoQuantityUsageType | null;
    /**
     * 
     * @type {SetupQuantityUsageDto}
     * @memberof NumericQuantityDto
     */
    setupUsage?: SetupQuantityUsageDto;
    /**
     * 
     * @type {EvaluationQuantityUsageDto}
     * @memberof NumericQuantityDto
     */
    evaluationUsage?: EvaluationQuantityUsageDto;
    /**
     * 
     * @type {string}
     * @memberof NumericQuantityDto
     */
    $type?: NumericQuantityDtoTypeEnum;
}


/**
 * @export
 */
export const NumericQuantityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoNumericQuantityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.NumericQuantityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type NumericQuantityDtoTypeEnum = typeof NumericQuantityDtoTypeEnum[keyof typeof NumericQuantityDtoTypeEnum];


/**
 * Check if a given object implements the NumericQuantityDto interface.
 */
export function instanceOfNumericQuantityDto(value?: unknown): value is NumericQuantityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(NumericQuantityDtoTypeEnum)[0];
}

export function NumericQuantityDtoFromJSON(json: any): NumericQuantityDto {
    return NumericQuantityDtoFromJSONTyped(json, false);
}

export function NumericQuantityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NumericQuantityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': !exists(json, 'creationTime') ? undefined : json['creationTime'],
        'creatorUserId': !exists(json, 'creatorUserId') ? undefined : json['creatorUserId'],
        'lastModificationTime': !exists(json, 'lastModificationTime') ? undefined : json['lastModificationTime'],
        'lastModifierUserId': !exists(json, 'lastModifierUserId') ? undefined : json['lastModifierUserId'],
        'commentCount': !exists(json, 'commentCount') ? undefined : json['commentCount'],
        'commentAttachmentsCount': !exists(json, 'commentAttachmentsCount') ? undefined : json['commentAttachmentsCount'],
        'lastComment': !exists(json, 'lastComment') ? undefined : json['lastComment'],
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'origin': !exists(json, 'origin') ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': !exists(json, 'possibleActions') ? undefined : (json['possibleActions'] === null ? null : (json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': !exists(json, 'creatorUser') ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': !exists(json, 'lastModifierUser') ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': !exists(json, 'editingUser') ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': !exists(json, 'editingTime') ? undefined : json['editingTime'],
        'comments': !exists(json, 'comments') ? undefined : (json['comments'] === null ? null : (json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': !exists(json, 'attachments') ? undefined : (json['attachments'] === null ? null : (json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': !exists(json, 'isReferenced') ? undefined : json['isReferenced'],
        'isReferencedBy': !exists(json, 'isReferencedBy') ? undefined : (json['isReferencedBy'] === null ? null : (json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': !exists(json, 'state') ? undefined : StateOfUseFromJSON(json['state']),
        'name': json['name'],
        'iuid': !exists(json, 'iuid') ? undefined : json['iuid'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'quantityUsageType': !exists(json, 'quantityUsageType') ? undefined : EnumerationQuantityDtoQuantityUsageTypeFromJSON(json['quantityUsageType']),
        'setupUsage': !exists(json, 'setupUsage') ? undefined : SetupQuantityUsageDtoFromJSON(json['setupUsage']),
        'evaluationUsage': !exists(json, 'evaluationUsage') ? undefined : EvaluationQuantityUsageDtoFromJSON(json['evaluationUsage']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function NumericQuantityDtoToJSON(value?: NumericQuantityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'lastModificationTime': value.lastModificationTime,
        'commentCount': value.commentCount,
        'commentAttachmentsCount': value.commentAttachmentsCount,
        'lastComment': value.lastComment,
        'isAvailable': value.isAvailable,
        'origin': EntityOriginToJSON(value.origin),
        'creatorUser': UserCatalogDtoToJSON(value.creatorUser),
        'lastModifierUser': UserCatalogDtoToJSON(value.lastModifierUser),
        'editingUser': UserCatalogDtoToJSON(value.editingUser),
        'editingTime': value.editingTime,
        'comments': value.comments === undefined ? undefined : (value.comments === null ? null : (value.comments as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value.attachments === undefined ? undefined : (value.attachments === null ? null : (value.attachments as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value.isReferenced,
        'isReferencedBy': value.isReferencedBy === undefined ? undefined : (value.isReferencedBy === null ? null : (value.isReferencedBy as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': StateOfUseToJSON(value.state),
        'name': value.name,
        'iuid': value.iuid,
        'description': value.description,
        'quantityUsageType': EnumerationQuantityDtoQuantityUsageTypeToJSON(value.quantityUsageType),
        'setupUsage': SetupQuantityUsageDtoToJSON(value.setupUsage),
        'evaluationUsage': EvaluationQuantityUsageDtoToJSON(value.evaluationUsage),
        '$type': value.$type,
    });
}

